/**
 * Canonical "Plan a Service" / "Plan around an Occasion" CTA copy + icons.
 *
 * Single source of truth used by:
 *  - /me Dashboard Upcoming tiles (UserProfilePage.jsx)
 *  - Experiences tab empty state (ExperiencesPage.jsx)
 *  - Persistent top-of-tab buttons (PlanButtons.jsx)
 *
 * Per master spec: copy and icons must NOT diverge. Any change here
 * propagates everywhere instantly. Admin-editable copy is wired through
 * GET /api/admin/cta-copy (override) - this is the static fallback.
 */

import { Sparkles, PartyPopper } from "lucide-react";
import { CATEGORY_PRESETS } from "@/lib/categoryConfig";

export const PLAN_CTAS = {
  service: {
    title: "Plan a Service",
    subtitle: "Hair, Makeup, Nails, Lashes",
    // Sparkles is the canonical brand icon for the cross-category Plan-a-Service CTA
    // (NOT a single-category icon like makeup-brush - this CTA spans all categories).
    icon: Sparkles,
    iconColor: CATEGORY_PRESETS.makeup.iconColor, // canonical purple #9c57f5
    bgColor: CATEGORY_PRESETS.makeup.bgColor || "#f2e9ff",
    testid: "plan-experience-btn",
  },
  occasion: {
    title: "Plan around an Occasion",
    subtitle: "Wedding, Birthday, Photoshoot",
    icon: PartyPopper,
    iconColor: "#374151",
    bgColor: "#F9FAFB",
    testid: "plan-event-btn",
  },
};

export default PLAN_CTAS;
